module.exports = __webpack_public_path__ + "static/media/aldi.f3e90ed1.ttf";